import { track } from '@ninjacart/nc-gamification-module-app';
import { version } from '../../package.json';
import { SQSClient, SendMessageCommand } from '@aws-sdk/client-sqs';
import { DeviceUUID } from 'device-uuid';
import { get } from 'lodash';
/* 
launch
close
login successful
*/

/* 

SAMPLE_DATA
{
    "AppEvent": {
        "id": "6qabeeeelaa888aaaaad",
        "name": "Test Event",
        "type": "EventType",
        "subType": "EventSubType",
        "description": "Event Description",
        "externalId": "99001111anncccccadd",// empty
        "sourceDetails": {
            "sourceType": "Ninjacart"// agnet
        },
        "userDetails": {
            "userId": "1646653",
            "userName": "sharukh2308",
            "realmId": "ddc88111-999111-111111"
        },
        "experiment": {// empty
            "tagId": "265",
            "featureId": "19901111"
        },
        "payload": {
            "entityFields": [ // empty
                {
                    "entityName": "CashTransaction",
                    "id": "29901111",
                    "additionalDetails": [
                        {
                            "id": "819111",
                            "entityId": "29901111",
                            "refType": "FromUser",
                            "refValue": "1646653"
                        },
                        {
                            "id": "819111",
                            "entityId": "29901111",
                            "refType": "ToUser",
                            "refValue": "1646654"
                        }
                    ]
                }
            ]
        },
        "variations": [// empty
            {
                "id": "819111",
                "name": "CashTransaction",
                "description": "Transaction created",
                "additionalDetails": [
                    {
                        "id": "819111",
                        "entityId": "29901111",
                        "refType": "Previous",
                        "refValue": ""
                    },
                    {
                        "id": "819111",
                        "entityId": "29901111",
                        "refType": "Current",
                        "refValue": "{\"toUser\": \"1646654\"}"
                    }
                ]
            }
        ],
        "additionalDetails": [ // empty
            {
                "id": "819111",
                "entityId": "29901111",
                "refType": "FromUser",
                "refValue": "1646653"
            },
            {
                "id": "819111",
                "entityId": "29901111",
                "refType": "ToUser",
                "refValue": "1646654"
            }
        ],
        "appDetails": {
            "appType": "Mobile", // agnetwork
            "appId": "26", // empty
            "appVersion": "1.0.0-Alpha", // pkg version
            "appVersionName": "Staging Alpha",// empty
            "deviceId": "2788999", // e9dc90ac-d03d-4f01-a7bb-873e14556d8e
            "url": "https://freewheel.ninjacart.in", // location.host
            "browser": "chrome"
        },
        "screenDetails": {
            "screen": "homescreen", // route name
            "sessionId": ""
        }
    }
}

*/

/**
 *
 * @param {Object} eventData
 * @param {string} eventData.name
 * @param {string} eventData.type
 * @param {string} eventData.description
 * @param {screen} eventData.screen
 * @returns
 */
function generateEventStream(eventData) {
  const { name, type, description } = eventData;
  if (!name || !type) {
    console.error('Event data is invalid');
  }
  // return {};
  const authData = localStorage.getItem('AUTH_CONFIG');
  let parsedAuthData = authData ? JSON.parse(authData) : {};
  if (name === 'CLOSE_LOGIN') {
    parsedAuthData = get(eventData, 'authData', {});
  }
  const du = new DeviceUUID();
  const parsedDu = du.parse();
  const deviceUuid = du.get();

  return {
    AppEvent: {
      id: '',
      /* //
      userLoggedin
        userLoggedout
        userOnboarded
        appLaunced
      // */
      name,
      type,
      subType: '',
      description: description || '',
      externalId: '', // empty
      sourceDetails: {
        sourceType: 'agnet' // agnet
      },
      userDetails: {
        userId: get(parsedAuthData, 'userId', ''),
        userName: get(
          parsedAuthData,
          'userRealmsDetails.realms[0].realmName',
          ''
        ),
        realmId: get(
          parsedAuthData,
          'userRealmsDetails.realms[0].realmIdentifier',
          ''
        )
      },
      experiment: {},
      payload: {
        entityFields: get(eventData, 'entityFields', [])
      },
      variations: get(eventData, 'variations', []),
      additionalDetails: get(eventData, 'additionalDetails', []),
      appDetails: {
        appType: 'agnetwork', // agnetwork
        appId: '', // empty
        appVersion: version, // pkg version
        appVersionName: '', // empty
        deviceId: deviceUuid, // e9dc90ac-d03d-4f01-a7bb-873e14556d8e
        url: window?.location?.origin, // location.host
        browser: parsedDu
      },
      screenDetails: {
        screen: screen || '', // route name
        sessionId: ''
      }
    }
  };
}

/**
 *
 * @param {Object} eventData
 * @param {string} eventData.name
 * @param {string} eventData.type
 * @param {string} eventData.description
 * @param {screen} eventData.screen
 * @returns
 */
export function gamification(eventData) {
  const config = generateEventStream(eventData);
  const command = new SendMessageCommand({
    QueueUrl: process.env.AWS_QUEUE_URL,
    MessageBody: JSON.stringify(config)
  });

  const environment = {
    awsSqsEntity: {
      region: process.env.AWS_REGION,
      awsAccessKeyId: process.env.AWS_ACCESS_KEY_ID,
      awsSecretAccessKey: process.env.AWS_SECRET_ACCESS_KEY
    }
  };
  const result = track(eventData.type, {
    eventData: command,
    environment
  });
}
